import React, { Component } from "react";
import ColButton from "../../../Elements/ColButton";
import MessageDiv from "../../../Elements/MessageDiv";
import OverWindow from "../../../Elements/OverWindow";
import mathHelper from "../../../Helpers/mathHelper";
import TargetRate from "../PlanningItem/TargetRate";
import ButtonFooterContainer from "../../../Elements/ButtonFooterContainer";

class PDMultiEditBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numberOfPlannedAssignments: typeof props.numberOfPlannedAssignments === "undefined" || props.numberOfPlannedAssignments < 0 ? 0 : props.numberOfPlannedAssignments,
      applyValue: false,
      targetAssignmentRate: [30, 45, 25, 0],
      targetCompletionRate: [20, 30, 30, 20],
    };
  }

  componentDidMount() {}

  renderNumberOfPlannedAssignmentField() {
    return (
      <div className="col hover rounded p-1">
        <p className="m-1 text-center">Number of Planned Assignments</p>
        <input
          type="number"
          min="0"
          className="form-control  form-control-sm text-center"
          value={this.state.numberOfPlannedAssignments}
          onChange={(e) => {
            let val = parseInt(e.target.value);
            val = isNaN(val) ? 0 : val;
            this.setState({ numberOfPlannedAssignments: val });
          }}
        />
      </div>
    );
  }

  renderApplyTargetRateCheckBox() {
    return (
      <div className="col hover rounded p-1">
        <p className="m-1 text-center">Apply Target Rates</p>
        <div className="m-1 d-flex align-items-center justify-content-center ">
          <input
            type="checkbox"
            checked={this.state.applyValue}
            onChange={(e) => {
              this.setState({ applyValue: e.target.checked });
            }}
          />
        </div>
      </div>
    );
  }

  renderTargetRate(labeltext, ratename) {
    return (
      <div className="col hover rounded p-1">
        <p className="m-1 text-center">Target {labeltext} Rate (%)</p>
        <TargetRate
          rates={this.state[ratename]}
          disabled={!this.state.applyValue}
          onChange={(value) => {
            this.setState({ [ratename]: value });
          }}
        />
      </div>
    );
  }

  render() {
    return (
      <OverWindow
        headerText="PlanningDetail MultiEdit"
        clickOnCancel={this.props.clickOnCancel}
        iconName="fa-solid fa-edit"
        title="MultiEdit"
      >
        <div className="container-fluid">
          <div className="row d-flex">
            {this.renderNumberOfPlannedAssignmentField()}
            {this.renderApplyTargetRateCheckBox()}
            {this.renderTargetRate("Assignment", "targetAssignmentRate")}
            {this.renderTargetRate("Completion", "targetCompletionRate")}
          </div>
        </div>
        <MessageDiv message="Only the selected and editable items will be modified." />
        <ButtonFooterContainer>
          <ColButton
            text="Cancel"
            onClick={this.props.clickOnCancel}
          />
          <ColButton
            text="Modify all selected"
            onClick={() => {
              let data = {
                numberOfPlannedAssignments: this.state.numberOfPlannedAssignments,
                applyValue: this.state.applyValue,
                targetAssignmentRate: this.state.targetAssignmentRate,
                targetCompletionRate: this.state.targetCompletionRate,
              };
              this.props.submitHandler(data);
            }}
            disabled={
              this.state.numberOfPlannedAssignments < 0 ||
              (this.state.applyValue && (mathHelper.Sum(this.state.targetCompletionRate) !== 100 || mathHelper.Sum(this.state.targetAssignmentRate) !== 100))
            }
            icon="fa-solid fa-save"
          />
        </ButtonFooterContainer>
      </OverWindow>
    );
  }
}

export default PDMultiEditBox;
